import { createFileRoute, notFound } from '@tanstack/react-router';

import EstimationDetailPage from '@/pages/estimation/detail';
import { tabsConfiguration } from '@/pages/estimation/detail/config';

export const Route = createFileRoute('/estimation/detail/$estimationId/$tabId')({
  component: EstimationDetailPage,
  beforeLoad: (ctx) => {
    const isCorrectTabId = tabsConfiguration.some((x) => x.tabId.toString() === ctx.params.tabId);
    if (!isCorrectTabId) {
      throw notFound();
    }
  },
  loader: ({ params }) => params,
});
